export default "__VITE_ASSET__CvKIU1qS__"